import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import MarketingActionsListItem from 'app/main/modules/marketingactions/MarketingActionsListItem';
import DemsListItem from 'app/main/modules/dems/DemsListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import ContractsListItem from 'app/main/modules/contracts/ContractsListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import TicketsListItem from 'app/main/modules/tickets/TicketsListItem';

import GroupsDetailsTab from './tabs/GroupsDetailsTab';

import GroupsUsersListItem from '../groups-users/GroupsUsersListItem';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <GroupsDetailsTab {...props} />
	},
	{
		id: 'users',
		title: 'TAB_GROUPS_USERS',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'users'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="groups_users"
				content={{ type: 'list', itemLayout: GroupsUsersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'grus_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'marketingactions',
		title: 'MODULE_MARKETINGACTIONS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('marketingactions') || authorizer.cannot('view', 'marketingactions'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="marketingactions"
				content={{ type: 'list', itemLayout: MarketingActionsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'maac_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'dems',
		title: 'MODULE_DEMS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('dems') || authorizer.cannot('view', 'dems'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="dems"
				content={{ type: 'list', itemLayout: DemsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'dems_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'oppo_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'contracts',
		title: 'MODULE_CONTRACTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('contracts') || authorizer.cannot('view', 'contracts'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="contracts"
				content={{ type: 'list', itemLayout: ContractsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'cntr_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'ords_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	},
	{
		id: 'tickets',
		title: 'MODULE_TICKETS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('tickets') || authorizer.cannot('view', 'tickets'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="tickets"
				content={{ type: 'list', itemLayout: TicketsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'tick_grps_uid', filt_clause: 'equals', filt_value: model.grps_uid }]}
			/>
		)
	}
];

export default tabs;
